import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeHeading4,
  BaSeParagraph,
  BaSeButton,
  BaSeIcon,
  BaSeTheme,
} from '@base/react';
import { ResultSearchCertificate, WrapperButtonCertificate } from './resultado-styled';

export const ResultadoInvalido = () => {
  const { navigateTo } = Sebrae.useRouter();
  const { azulSebrae36 } = BaSeTheme.colors.institucionais;
  const { erro35 } = BaSeTheme.colors.feedbackInterface
  return (
    <ResultSearchCertificate>
      <BaSeIcon
        name="times-circle"
        description="certificado invalido"
        color={erro35}
      />
      <BaSeHeading4>Certificado Inválido</BaSeHeading4>
      <BaSeParagraph>
        Os dados informados não correspondem a um certificado válido
      </BaSeParagraph>
      <BaSeParagraph>
        Favor tentar novamente ou entrar em contato conosco
      </BaSeParagraph>
      <WrapperButtonCertificate>
        <BaSeButton
          buttonType="button"
          color={azulSebrae36}
          onClick={() => navigateTo(`/`)}
          size="medium"
          type="primary"
          value="Tentar novamente"
          width="176"
        />
        <BaSeButton
          buttonType="button"
          color={azulSebrae36}
          onClick={() =>
            navigateTo(
              'https://www.sebrae.com.br/sites/PortalSebrae/faleconosco',
            )
          }
          size="medium"
          type="secondary"
          value="Fale conosco"
          width="176"
        />
        {/* <Button
          onClick={() => { window.location.replace('https://www.sebrae.com.br/sites/PortalSebrae/faleconosco') }}
          variant="outlined"
          color="primary"
        >
          Fale conosco
            </Button> */}
      </WrapperButtonCertificate>
    </ResultSearchCertificate>
  );
};
